// extracted by mini-css-extract-plugin
export var createdDate = "_l5-1";
export var divider = "_l5-2";
export var headerDivider = "_l5-3";
export var messagesCard = "_l5-0";
export var messagesContainer = "_l5-6";
export var messagesContainerWrapper = "_l5-4";
export var showLeftPanelButton = "_l5-8";
export var topButtons = "_l5-7";
export var withPadding = "_l5-5";